var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeSpins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 252,
    viewBox: "0 0 252 252"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rv97nlju2a",
    x1: "74.74%",
    x2: "0%",
    y1: "17.012%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7EEFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A6B49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#rv97nlju2a)",
    fillRule: "nonzero",
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.368 149.999a112.936 112.936 0 00-12.647-43.78C230.883 44.947 149.34 25.35 97.003 67.97 71.121 89.053 59.06 120.767 63.337 150c4.663 31.19 26.843 58.23 59.124 65.559 42.188 9.584 80.568-21.68 75.436-61.426a41.065 41.065 0 00-.755-4.133c-2.903-11.425-9.152-21.366-19.471-26.86-17.093-9.091-34.116-4.626-45.952 14.073 3.002-14.024 12.485-22.062 25.108-24.637 21.45-4.36 41.438 11.555 48.068 34.566.266.94.51 1.883.73 2.827 6.212 26.43-8.527 56.807-38.136 69.692-39.603 17.246-88.021-3.03-105.981-44.347a104.854 104.854 0 01-7.398-25.333C46.444 98.238 75.678 45.515 125.62 29.347c8.177-2.655 13.215-3.579 22.635-4.638-6.635-.893-23.953 1.275-29.858 3.018-45.085 13.292-80.674 43.583-91.2 92.296A113.798 113.798 0 0024.626 150a112.797 112.797 0 0012.641 43.78c31.838 61.272 113.386 80.87 165.718 38.255 25.882-21.083 37.006-52.803 32.73-82.035-4.663-31.19-25.913-58.23-58.181-65.559-42.182-9.584-81.423 21.68-76.26 61.432a41.25 41.25 0 00.76 4.127c2.897 11.425 9.99 21.366 20.314 26.86 17.074 9.098 34.123 4.626 45.959-14.092-3.003 14.03-12.517 22.069-25.108 24.637-21.456 4.36-42.369-11.555-48.999-34.566a52.098 52.098 0 01-.724-2.827c-6.242-26.423 9.445-56.8 39.054-69.685 39.604-17.246 88.022 3.024 105.982 44.346 3.602 8.284 4.938 16.784 6.299 25.327 7.666 51.768-20.489 104.485-70.411 120.66-8.178 2.648-13.216 3.572-22.636 4.631 6.636.9 23.953-1.275 29.858-3.012 45.085-13.298 80.68-43.564 91.206-92.302a113.746 113.746 0 002.54-29.977z"
  })))));
}
SvgFreeSpins.displayName = 'FreeSpins';
export default SvgFreeSpins;